import './infos.scss'

function Infos(){
    return(
      <section id="infos">
          <h2 className="fs-40">À propos</h2>
          <article className="pres">
              <p><span className="marge"></span>
                Né le 7 juin 1995 en Belgique, j'ai grandi en Amérique Latine durant mon enfance avant de m'installer en France. Autonome, précis et consciencieux, <strong>je m'adapte facilement à de nouveaux environnements</strong>.
              </p>
              <p><span className="marge"></span>
                <strong>Passionné de nouvelles technologies</strong>, je me suis d'abord orienté vers le développement web et je cherche désormais à approfondir mes compétences techniques pour me <strong>spécialiser à terme dans la domotique et les bâtiments intelligents</strong>.
              </p>
              <p><span className="marge"></span>
                Titulaire d'un Titre Professionnel Développeur Web et Web Mobile (RNCP niv. 5) obtenu en septembre 2023, j'ai travaillé dans la restauration, la formation linguistique et le développement web avant de me réorienter vers l'électricité.
              </p>
          </article>
        </section>
    )
}
export default Infos